import { call, put, select, spawn, take } from 'redux-saga/effects';

import { actions as globalActions } from '@elab/core/store/global';
import { actions as uiActions } from '@elab/core/store/ui';
import { types as authTypes } from '@elab/core/store/auth';
import { actions, types } from '@elab/core/store/notifyme';
import { deleteCookie, getCookie, setCookie } from '@elab/core/utils/cookie';
import { application } from '@elab/core/utils/appData';
import { getLoginRedirectURL } from '@elab/core/utils/appNavigation';
import * as address from '@elab/core/utils/address';
import { selectors as configSelectors } from '@elab/core/store/config';

import { setNotifyProductCookie } from '../helpers';

import { addWithDialog, addWithRedirect } from './loggedInUser';

// redirects guest to login page after 'add to to notify me list' action
// [Applied on: ICI]

export function* redirect(productCode) {
    yield call(setNotifyProductCookie, productCode);
    
    const shouldRedirectToPDPAfterLogin = yield select(configSelectors.getRedirectToPDPAfterLogin);
    if (shouldRedirectToPDPAfterLogin) {
        const currentURL = yield call(address.getURL);
        yield put(globalActions.setPrevPageData({ url: currentURL }));
    }
    const redirectURL = yield call(getLoginRedirectURL);
    yield put(uiActions.closeDialog());
    yield put(globalActions.redirect({ successRedirectUrl: redirectURL }));
    yield spawn(afterGuestLoggedInHandler);
}

export function* afterGuestLoggedInHandler() {
    yield take(authTypes.LOGIN_DONE);
    yield put(actions.loadNotifyMeList());
    const productCookieName = `${application.baseSiteId}-my-account/notification`;
    const productCode = yield call(getCookie, productCookieName);
    yield take(types.SET_NOTIFY_ME_LIST);
    const strategies = yield select(configSelectors.getAddToNotifyMeListStrategies);
    if (strategies.loggedInUser === 'addWithDialog') {
        // create a separate cookie to track whether the notify popup dialog has been displayed.
        // this is necesary because we cannot use uiActions across pages.
        yield call(addWithDialog, productCode);
        setCookie(`${application.baseSiteId}-show-notify-me`, true);
    } else {
        yield call(addWithRedirect, productCode);
    }
    yield call(deleteCookie, productCookieName);
}
